
import { useState } from "react";
import { ScoresState } from "./types";
import { resetScoresForTest } from "./scoreUtils";

export const useScoreManagement = (initialScores: ScoresState) => {
  const [scores, setScores] = useState<ScoresState>(initialScores);

  const updateScore = (point: string, attempt: number, score: number) => {
    console.log(`updateScore called - point: ${point}, attempt: ${attempt}, score: ${score}`);
    console.log("Current scores before update:", JSON.stringify(scores));
    
    setScores(prev => {
      // Create a new object to avoid mutating the previous state
      const newScores = { ...prev };
      
      // Initialize the array for this point if it doesn't exist
      if (!newScores[point]) {
        newScores[point] = Array(10).fill(null);
      }
      
      // Create a copy of the array to ensure the state update is detected
      const pointScores = [...(newScores[point] || Array(10).fill(null))];
      pointScores[attempt] = score;
      newScores[point] = pointScores;
      
      console.log("Updated scores:", JSON.stringify(newScores));
      
      // Pour le niveau 2, si le point est A et nous sommes dans un test iron-*, fairwayWood-* ou driver-*,
      // synchroniser avec le point D
      const pathname = window.location.pathname;
      if (pathname.includes('level2') && point === 'A') {
        const testId = pathname.split('/').pop();
        
        if (testId && (testId.includes('iron-') || testId.includes('fairwayWood-') || testId.includes('driver-'))) {
          console.log("Synchronizing point A with point D for Level 2 iron/fairwayWood/driver test");
          
          // Initialiser D si nécessaire
          if (!newScores['D']) {
            newScores['D'] = Array(10).fill(null);
          }
          
          // Copier le score de A à D
          const dScores = [...(newScores['D'] || Array(10).fill(null))];
          dScores[attempt] = score;
          newScores['D'] = dScores;
        }
      }
      
      console.log("Scores after update:", newScores);
      return newScores;
    });
  };

  const clearScore = (point: string, attempt: number) => {
    console.log(`clearScore called - point: ${point}, attempt: ${attempt}`);
    console.log("Current scores before clear:", JSON.stringify(scores));
    
    setScores(prev => {
      const newScores = { ...prev };
      
      if (newScores[point]) {
        // Create a copy of the array to ensure the state update is detected
        const pointScores = [...newScores[point]];
        pointScores[attempt] = null;
        newScores[point] = pointScores;
      }
      
      // Pour le niveau 2, si le point est A et nous sommes dans un test iron-*, fairwayWood-* ou driver-*,
      // synchroniser avec le point D
      const pathname = window.location.pathname;
      if (pathname.includes('level2') && point === 'A') {
        const testId = pathname.split('/').pop();
        
        if (testId && (testId.includes('iron-') || testId.includes('fairwayWood-') || testId.includes('driver-'))) {
          console.log("Synchronizing cleared point A with point D for Level 2 iron/fairwayWood/driver test");
          
          if (newScores['D']) {
            const dScores = [...newScores['D']];
            dScores[attempt] = null;
            newScores['D'] = dScores;
          }
        }
      }
      
      console.log("Scores after clear:", JSON.stringify(newScores));
      return newScores;
    });
  };

  const resetScores = (testId: string) => {
    console.log(`resetScores called for test: ${testId}`);
    setScores(resetScoresForTest(testId, scores));
  };

  return {
    scores,
    setScores,
    updateScore,
    clearScore,
    resetScores
  };
};
